export const contactSupportText =
  "please contact the IT support at itsupport@caipa.com.";
